import type { IconName } from '@eliadmin/core/src/components/dlz/ui/icon';

/** Fixed UI copy of the sign-in templates; wording the core dictionary has is read with `t('textNNN')`. */
export const SIGN_IN_COPY = {
  intro: 'Zadajte e-mail a heslo, ktoré ste použili pri registrácii.',
  emailPlaceholder: 'martakovacova@gmail.com',
  passwordPlaceholder: '••••••••••',
  remember: 'Zapamätať si ma',
  forgotPassword: 'Zabudli ste heslo?',
  secureNote: 'Vaše údaje sú chránené šifrovaným pripojením.',
} as const;

/** Name of the „Zobraziť na“ value that marks a benefit (section „Výhody“) for this page. */
export const SIGN_IN_BENEFIT_VALUE = 'Prihlásenie';

export type SignInBenefitCopy = { title: string; text: string; icon: IconName };

/** Shown while the administration has no benefit marked for the sign-in page (Figma 60155:18098). */
export const SIGN_IN_BENEFITS_FALLBACK: readonly SignInBenefitCopy[] = [
  {
    icon: 'truck',
    title: 'Prehľad objednávok a faktúr',
    text: 'Stav objednávky aj doklady na jednom mieste',
  },
  {
    icon: 'shopping-cart',
    title: 'Rýchlejší nákup',
    text: 'Uložené adresy a údaje pri ďalšej objednávke',
  },
  { icon: 'key', title: 'Vernostné body', text: 'Za nákupy aj hodnotenia produktov' },
  {
    icon: 'star',
    title: 'Firemné výhody',
    text: 'Nákup na faktúru a individuálne ceny pre firmy',
  },
];
